// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3xaJM","spinnerContainer":"Button_spinnerContainer__m2nrN","spinner":"Button_spinner__1euk3"};